export default (string) => {
  string = string.toString();
  return string.split(' ').join('');
};
